import { rest, graphql } from "msw";

export const localDevHandler = [
  //sentry
  rest.post(/api\/\d+\/(store|envelope)\//, (_, res, ctx) => {
    return res(ctx.json({}));
  }),
  //snowplow event context array for Cart app
  rest.post("/tracking-contexts", (_, res, ctx) => {
    return res(ctx.json([]));
  }),
  //snowplow PageView event context
  rest.get("/sp-context/*", (_, res, ctx) => {
    return res(ctx.json({}));
  }),
  //snowplow event array for experiment
  rest.get("/sp-experiment-events/*", (_, res, ctx) => {
    return res(ctx.json([]));
  }),
  //user-location call for @header-app/DeliveryLocation component
  rest.get("/user-location", (_, res, ctx) => {
    return res(ctx.json([]));
  }),
  //header loyalty details call
  rest.get("/header/loyalty.json", (_, res, ctx) => {
    return res(ctx.json([]));
  }),
  //Experiments Graphql Query mock
  graphql.query("Experiments", (_, res, ctx) => {
    const result = {
      experiments: {
        experiments: [
          {
            experiment: "exp1",
            bucket: 0,
            variation: "control",
            active: true,
            id: "1",
            name: "Experiment 1",
          },
          {
            experiment: "exp2",
            bucket: 1,
            variation: "experiment",
            active: true,
            id: "2",
            name: "Experiment 2",
          },
          {
            experiment: "exp3",
            variation: "control",
            bucket: 0,
            active: false,
            id: "3",
            name: "Experiment 3",
          },
        ],
        __typename: "ExperimentsPayload",
      },
    };

    return res(ctx.data(result));
  }),
];
